import { createSlice } from "@reduxjs/toolkit";
import { 
  getReferralFlow, 
  createReferralFlow, 
  updateReferralFlow, 
  deleteReferralFlow,
  clearLocalActiveReferralFlow 
} from "./actions";

export const initialState = {
  referralFlow: { 
    id: '', 
    start_weekdays: '',
    start_frequency: 'day',
    start_offset: '', 
    time_zone: '', 
    updated_at: '' 
  },
  loading: false
};

const slice = createSlice({
  name: 'referralFlows',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getReferralFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(getReferralFlow.fulfilled, (state, action) => {
        const { referral_flow } = action.payload;
        const referralFlow = { ...state.referralFlow, ...referral_flow };

        state.loading = false;
        state.referralFlow = referralFlow;
      })
      .addCase(getReferralFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(createReferralFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(createReferralFlow.fulfilled, (state, action) => {
        const { referral_flow } = action.payload;

        state.loading = false;
        state.referralFlow = referral_flow;       
      })
      .addCase(createReferralFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(updateReferralFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateReferralFlow.fulfilled, (state, action) => {
        const { status, referral_flow } = action.payload;
        const updatedReferralFlow = { ...state.referralFlow, ...referral_flow };

        state.loading = false;
        if (status === 204) state.referralFlow = updatedReferralFlow;       
      })
      .addCase(updateReferralFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(deleteReferralFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteReferralFlow.fulfilled, (state, action) => {
        const { status } = action.payload;

        state.loading = false;
        if (status === 204) state.referralFlow = initialState.referralFlow;       
      })
      .addCase(deleteReferralFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(clearLocalActiveReferralFlow, state => {
        state.referralFlow = initialState.referralFlow;
      })
  }
})

export default slice.reducer;